export enum UserPerspective {
  Staff = 'staff',
  Patient = 'patient',
}
